






























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ColumnsFilter from '@/components/worksheets/ColumnsFilter.vue';
import { Action, Getter } from 'vuex-class';
import type { CompanySetting } from '@/models/companySetting';
import FormDynamicFieldMultiselect from '@/components/form/FormDynamicFieldMultiselect.vue';
import type { DynamicField } from '@/models/dynamicField';
import FormPhaseMultiselect from '@/components/form/FormPhaseMultiselect.vue';
import type { Phase } from '@/models/phase';
import PrintMultipleWorksheets from '@/components/worksheets/PrintMultipleWorksheets.vue';
import type { Trade } from '@/models/trade';
import type { Topic } from '@/models/topic';
import FormTopicPicker from '@/components/form/FormTopicPicker.vue';
import { isDesktop } from '@/helpers/isDesktop';
import type { PMPhase } from '@/models/pmphase';
import type { XSubProcessGroup } from '@/models/xsubprocess';
import type { XProcess } from '@/models/xprocess';
import type { PMSubPhaseGroup } from '@/models/pmsubphase';
import type { Project } from '@/models/project';
import { ResolvedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsResolved';
import { CheckedEnum } from '@/helpers/filter/appliedLessons/filterAppliedLessonsChecked';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import { printMultipleWorksheetsPermissions } from '@/helpers/auth/commonPermissions';

@Component({
    name: 'ProjectViewFilterPanel',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        FormPhaseMultiselect,
        FormDynamicFieldMultiselect,
        ColumnsFilter,
        PrintMultipleWorksheets,
        FormTopicPicker,
    },
})
export default class ProjectViewFilterPanel extends Vue {
    @Prop() private trades: Trade[];
    @Prop() private phases: Phase[];
    @Prop() private topics: Topic[];

    @Prop() private selectedTrades: Trade[];
    @Prop() private selectedPhases: Phase[];
    @Prop() private selectedTopics: Topic[];

    @Prop() private pmPhases: PMPhase[];
    @Prop() private pmSubPhasesGrouped: PMSubPhaseGroup[];
    @Prop() private selectedPmPhases: PMPhase[];
    @Prop() private selectedPmSubPhasesGrouped: PMSubPhaseGroup[];

    @Prop() private xProcesses: XProcess[];
    @Prop() private xSubProcessesGrouped: XSubProcessGroup[];
    @Prop() private selectedXProcesses: XProcess[];
    @Prop() private selectedXSubProcessesGrouped: XSubProcessGroup[];

    @Prop() private tableColumns: AppliedLessonsFilter;
    @Prop() private filterResolved: ResolvedEnum;
    @Prop() private filterChecked: CheckedEnum;
    @Prop() private dynamicFieldCounts: [];
    @Prop() private selectedDynamicFields: DynamicField[];
    @Prop() private selectedTabs: string[];
    @Prop() private defaultTab: string;

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('project/selectedProject') private selectedProject: Project;

    private isDesktop = isDesktop();

    @Action('company/fetchAllDynamicFields') private fetchAllDynamicFields: any;

    @Action('project/refreshSelectedProject') private refreshSelectedProject: any;

    private resolvedAll = ResolvedEnum.All;
    private resolvedResolved = ResolvedEnum.Resolved;
    private resolvedNotResolved = ResolvedEnum.NotResolved;

    private checkedAll = CheckedEnum.All;
    private checkedChecked = CheckedEnum.Checked;
    private checkedNeedsCheck = CheckedEnum.NeedsCheck;
    private checkedNotChecked = CheckedEnum.NotChecked;

    private selectedTabsIncludes(tab: string) {
        return this.selectedTabs.includes(tab);
    }

    get language() {
        return this.$i18n.locale;
    }

    get canPrintMultipleWorksheet() {
        return hasPermission(printMultipleWorksheetsPermissions);
    }

    get internalSelectedPmPhases() {
        return this.selectedPmPhases;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedPmPhases(value) {
        this.$emit('update:selected-pm-phases', value);
    }

    get internalSelectedPmSubPhases() {
        return this.selectedPmSubPhasesGrouped;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedPmSubPhases(value) {
        this.$emit('update:selected-pm-sub-phases-grouped', value);
    }

    get internalSelectedXProcesses() {
        return this.selectedXProcesses;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedXProcesses(value) {
        this.$emit('update:selected-x-processes', value);
    }

    get internalSelectedXSubProcesses() {
        return this.selectedXSubProcessesGrouped;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedXSubProcesses(value) {
        this.$emit('update:selected-x-sub-processes-grouped', value);
    }

    get internalSelectedTabs() {
        return this.selectedTabs;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedTabs(value) {
        this.$emit('update:selected-tabs', value);
    }

    get internalTableColumns() {
        return this.tableColumns;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalTableColumns(value) {
        this.$emit('update:table-columns', value);
    }

    get selectedResolvedFilter() {
        return this.filterResolved;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedResolvedFilter(value) {
        this.$emit('update:filter-resolved', value);
    }

    get selectedCheckedFilter() {
        return this.filterChecked;
    }

    // noinspection JSUnusedGlobalSymbols
    set selectedCheckedFilter(value) {
        this.$emit('update:filter-checked', value);
    }

    get internalSelectedTrades() {
        return this.selectedTrades;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedTrades(value) {
        this.$emit('update:selected-trades', value);
    }

    get internalSelectedPhases() {
        return this.selectedPhases;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedPhases(value) {
        this.$emit('update:selected-phases', value);
    }

    get internalSelectedTopics() {
        return this.selectedTopics;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedTopics(value) {
        this.$emit('update:selected-topics', value);
    }

    get internalSelectedDynamicFields() {
        return this.selectedDynamicFields;
    }

    // noinspection JSUnusedGlobalSymbols
    set internalSelectedDynamicFields(value) {
        this.$emit('update:selected-dynamic-fields', value);
    }

    get query() {
        const fields = Object.keys(this.tableColumns)
            .filter((key) => this.tableColumns[key].display)
            .map((key) => {
                const columnFields = [key.toLowerCase()];
                if (this.tableColumns[key] && this.tableColumns[key].additionalFields) {
                    columnFields.push(...this.tableColumns[key].additionalFields.map((f) => f.toLowerCase()));
                }
                return columnFields;
            })
            .flat();

        const fieldsString = fields.join(',');

        return {
            selectedTabs: this.selectedTabs,
            projectId: this.selectedProject.id,
            filterResolved: this.filterResolved,
            filterChecked: this.filterChecked,
            dynamicFields: this.tableColumns.dynamic_field.display
                ? this.selectedDynamicFields.map((dyn) => dyn.title)
                : '',

            tradeIds: this.selectedTrades.map((p) => p.id),
            phaseIds: this.selectedPhases.map((p) => p.id),
            topicIds: this.selectedTopics.map((el) => el.id),

            pmPhasesIds: this.selectedPmPhases.map((el) => el.id),
            pmSubPhasesIds: this.selectedPmSubPhasesGrouped.reduce(
                (acc: number[], group) => acc.concat(group.sub_phases_ids),
                []
            ),

            xProcessesIds: this.selectedXProcesses.map((el) => el.id),
            xSubProcessesIds: this.selectedXSubProcessesGrouped.reduce(
                (acc: number[], group) => acc.concat(group.sub_processes_ids),
                []
            ),

            fields: fieldsString,
        };
    }
}
